import type { TrackingData } from "../types/tracking";
import { JSONQuery } from "../types/suggestion";

export class SquirrelURL {
  private hashList: string[][];
  private url: URL;

  constructor(action: string) {
    /*                                                                                                                      */
    /*                                                                                                                                      */
    this.url = new URL(action);
    const path = this.url.pathname;
    const hash = this.url.hash;
    const params = this.url.searchParams;
    this.url = new URL(path + hash, window.location.origin);
    params.forEach((value, key) => {
      this.url.searchParams.set(key, value);
    });
    this.hashList = this.createHashList();
  }

  private createHashList(): string[][] {
    return (
      this.url.hash
        .split(/[#&]/)
        .filter((hash: string) => hash.length > 0)
        .map((hash: string) => hash.split(/=/)) || []
    );
  }

  get trackingParameter(): TrackingData {
    const response: string[][] = this.hashList.filter((hashItem: string[]) => hashItem[0] == "t");
    if (response.length <= 0) {
      return {};
    }
    const trackingValues: string = decodeURIComponent(response[0][1]);
    return JSON.parse(trackingValues);
  }

  get urlWithoutTrackingParameter(): string {
    const hashes: string = this.hashList
      .filter((hashItem: string[]) => hashItem[0] != "t")
      .map((p): string => SquirrelURL.hashItemToString(p))
      .join("&");
    const hashSymbol: string = hashes.length > 0 ? "#" : "";
    let params = "?";
    this.url.searchParams.forEach((value, key) => {
      params += key + "=" + value + "&";
    });
    params = params.substring(0, params.length - 1);
    return this.url.origin + this.url.pathname + params + hashSymbol + hashes || "";
  }

  private static hashItemToString(hashItem: string[]): string {
    return `${hashItem[0]}=${hashItem[1]}`;
  }

  /**
 *
 *
 *
 */
  static encode(url: string, json: JSONQuery): string {
    return url + "?" + Object.keys(json).map(SquirrelURL.param.bind(json)).join("&");
  }

  /**
 *
 *
 */
  static param(this: JSONQuery, key: string): string {
    return encodeURIComponent(key) + "=" + encodeURIComponent(this[key]);
  }
}
